import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

// The search works ONLY from 2 symbols!
// Why? Because https://linear.app/gymflow/issue/GYM-1034/global-search-for-2-symbols
// Additionally: use debounce 400ms for the request (general rule, it's not MUST)

export const memberSearchQueryFn = async (
  api: ApiType,
  {
    term,
    size,
  }: {
    term: string;
    size: number;
  },
) => {
  if (term.length < 2) {
    return [];
  }
  return (await api.memberApi.globalSearch(term, size)).data;
};

export function useMemberSearch({
  api,
  term,
  size,
}: {
  api: ApiType;
  term: string;
  size: number;
}) {
  return useQuery({
    queryKey: memberQueryKeys.search(term, size),
    queryFn: () => memberSearchQueryFn(api, { term, size }),
    enabled: !!term,
  });
}
